import Keycloak from 'keycloak-js';

let keycloak = null;
let initialized = false;

const REFRESH_THRESHOLD_SECONDS = 60;

export function isSkipAuth() {
    return HIVE_SKIP_AUTH === 'true';
}

export function getKeycloak() {
    if (!keycloak) {
        keycloak = new Keycloak({
            url: HIVE_KEYCLOAK_URL,
            realm: HIVE_KEYCLOAK_REALM,
            clientId: HIVE_KEYCLOAK_CLIENT_ID,
        });
    }

    return keycloak;
}

export async function initKeycloak() {
    if (initialized) return getKeycloak();

    const kc = getKeycloak();

    await kc.init({
        onLoad: 'login-required',
        checkLoginIframe: false,
        pkceMethod: 'S256',
    });

    initialized = true;

    return kc;
}

export async function getValidToken() {
    if (isSkipAuth()) return null;

    const kc = getKeycloak();

    if (!kc.authenticated) return null;

    try {
        await kc.updateToken(REFRESH_THRESHOLD_SECONDS);
    } catch (err) {
        console.error('Token refresh failed; redirecting to login.', err);
        kc.login();
        throw err;
    }

    return kc.token;
}

export function logout() {
    if (isSkipAuth()) return Promise.resolve();

    return getKeycloak().logout({ redirectUri: window.location.origin });
}

export function login() {
    return getKeycloak().login();
}

export function getTokenParsed() {
    return getKeycloak().tokenParsed;
}
